import { RootState } from '@/store/types';
import {
  OrderPaymentState,
  DailyStatistics,
  FeedbackStatistics
} from './types';
import { ActionTree } from 'vuex';
import {
  getFeedbackStatistics,
  getFeedbackStatisticsWeek,
  // getFeedbackReport,
  getCustomersSatisfaction
} from '@/services/axiosService';
import { OrderPaymentMutations } from './mutations';

const cleanLocalStorage = () => {
  localStorage.removeItem('users');
};

export const actions: ActionTree<OrderPaymentState, RootState> = {
  async getFeedbackStatistics(
    { commit },
    { pharmacyId, startTime, endTime, minutesInterval, chartFields }
  ) {
    try {
      const feedbackStatistics: FeedbackStatistics | undefined =
        await getFeedbackStatistics(
          pharmacyId,
          startTime,
          endTime,
          minutesInterval,
          chartFields
        );

      commit(OrderPaymentMutations.get_feedback_statistics, {
        feedbackStatistics
      });
    } catch (error: unknown) {
      cleanLocalStorage();
    }
  },
  async getFeedbackStatisticsWeek(
    { commit },
    { pharmacyId, startTime, endTime, minutesInterval, chartFields }
  ) {
    try {
      const feedbackStatisticsWeek: FeedbackStatistics | undefined =
        await getFeedbackStatisticsWeek(
          pharmacyId,
          startTime,
          endTime,
          minutesInterval,
          chartFields
        );

      commit(OrderPaymentMutations.get_feedback_statistics_week, {
        feedbackStatisticsWeek
      });
    } catch (error: unknown) {
      cleanLocalStorage();
    }
  },
  async getCustomersSatisfaction(
    { commit },
    { pharmacyId, startTime, endTime, otherPeriod }
  ) {
    try {
      const dailyStatistics: DailyStatistics | undefined =
        await getCustomersSatisfaction(
          pharmacyId,
          startTime,
          endTime,
          otherPeriod
        );

      commit(OrderPaymentMutations.get_daily_statistics, {
        dailyStatistics
      });
    } catch (error: unknown) {
      cleanLocalStorage();
    }
  }
  // async getFeedbackReport({ commit }, { pharmacyId, startTime, endTime }) {
  //   try {
  //     const feedbackReport: FeedbackReport | undefined =
  //       await getFeedbackReport(pharmacyId, startTime, endTime);
  //     console.log('feedbackReport', feedbackReport);

  //     commit(OrderPaymentMutations.get_feedback_report, {
  //       feedbackReport
  //     });
  //   } catch (error: unknown) {
  //     cleanLocalStorage();
  //   }
  // }
};
